import { persistAccessPair } from 'utils/sessionTokens';

const setTokenWithExpiry = (token: string, tokenExpiryTime?: string) => {
  persistAccessPair(token, tokenExpiryTime);
};

export default setTokenWithExpiry;
